export class OperationPointRequest {
  name: string = '';
  capacity: number | null | undefined = undefined;
  differentialPressure: number = 0;
  pumpSpeed: number | null | undefined = undefined;
}

export class OperationPoint {
  constructor(name: string) {
    this.name = name;
  }

  name: string = '';
  lastChangedInput: string = '';
  capacity: number | undefined | null;
  differentialPressure: number = 0;
  isDifferentialPressureExceeded: boolean | undefined;
  pumpSpeed: number | undefined | null;
  allowedSpeedMin: number | undefined;
  allowedSpeedMax: number | undefined;
  operatingPower: number | undefined;
  operatingTorque: number | undefined;
  volumetricEfficiency: number | undefined;
  mechanicalEfficiency: number | undefined;
  overallEfficiency: number | undefined;
  speedAt100VolumetricEfficiency: number | undefined;
  slidingVelocityAvg: number | undefined;
  slidingVelocityMin: number | undefined;
  slidingVelocityMax: number | undefined;
  npshr: number | undefined;
  npshrLow: number | undefined;
  toleranceLimitMin: number | undefined;
  toleranceLimitMax: number | undefined;
  motorSpeed: number | undefined;
  frequency: number | undefined;
  requiredMotorPowerSelfVentilated: number | undefined;
  requiredMotorPowerForcedVentilated: number | undefined;
  viscosityAdjustedPumpSpeed: number | undefined;
  viscosityAdjustedOperatingPowerAdder: number | undefined;
  viscosityAdjustedOperatingPower: number | undefined;
}

export interface OverallOperationPointData {
  chamberVolume: Number | undefined;
  maxStartingTorque: Number | undefined;
  maxAxialLoad: Number | undefined;
  maxOperatingPower: Number | undefined;
  maxStartingPower: Number | undefined;
  requiredRatedMotorPower: Number | undefined;
}

export interface CalculationResult {
  operationPoints: OperationPoint[];
  chamberVolume: Number | undefined;
  maxStartingTorque: Number | undefined;
  maxAxialLoad: Number | undefined;
  maxOperatingPower: Number | undefined;
  maxStartingPower: Number | undefined;
  requiredRatedMotorPower: Number | undefined;
}

export interface OperationPointDisplayResults {
  validPumpSpeedNormal: boolean | null;
  validPumpSpeedMin: boolean | null;
  validPumpSpeedMax: boolean | null;
  validPumpSpeedRated: boolean | null;
  validDifferentialPressureNormal: boolean | null;
  validDifferentialPressureMin: boolean | null;
  validDifferentialPressureMax: boolean | null;
  validDifferentialPressureRated: boolean | null;
  validFrequencyNormal: boolean | null;
  validFrequencyMin: boolean | null;
  validFrequencyMax: boolean | null;
  validFrequencyRated: boolean | null;
  minOverallEfficiency: string;
  minMechanicalEfficiency: string;
  minVolumetricEfficiency: string;
  maxOperatingTorque: string;
  maxNpsh: string;
  maxSpeedAt100VolumeetricEfficiency: string;
}
